export default function validation(response, messages) {
  if (!response?.data?.error?.validationErrors) return;
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('FORMAT_ACHAT_HAS_BOOL_ANNONCEUR_AND_FOURNISSEUR') === 0) {
      messages.push({ message: 'editionFormatAffiche.errors.hasBoolAnnonceurAndFournisseur' });
    }
  });
}
